module.exports = __webpack_public_path__ + "images/pages/lp/lens_1_0f0be788119ba69a5d992abb8a5201fe.png";